import Image from "next/image";
const MobileSlider = dynamic(() => import("./mobileSlider"),{ssr: true});
import dynamic from "next/dynamic";
const IpadCardTitle = dynamic(() => import("./IpadCardTitle"),{ssr: true});
import { toWebp } from "@/utils/common";
const CardTitle = dynamic(() => import("./CardTitle"), {
  ssr: false,
});

type softwareProps = {
  data?: any;
  isMobile?: boolean;
};

const Software: React.FC<softwareProps> = ({ isMobile, data  }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  return (
    <section className="xl:py-[100px] md:py-[80px] py-[56px] bg-[linear-gradient(96.18deg,_#E6F5FF_0%,_#5AA7DF_100%)] relative">
      {/* Background Image */}
      <div className=" bg-[linear-gradient(0deg,_rgba(255,_255,_255,_0.8),_rgba(255,_255,_255,_0.8))] absolute z-[1] top-0 left-0 inset-0"></div>
      <div className=" bg-[url(/images/enterprise-bg.png)] bg-size-[60%] bg-no-repeat bg-left-top absolute z-[2] top-0 left-0 inset-0"></div>
      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-start w-full mb-[40px]">
            <div className="sm:text-left xl:col-span-8 md:col-span-6">
              <h1 className="text-heading-1 md:text-heading-1 font-bold text-center text-primary-text md:text-left md:mb-[40px] mb-[12px] md:mt-[-0]">
                {data?.title}
              </h1>
            </div>
            <div className="sm:text-left xl:col-span-4 md:col-span-6">
              <p>{data?.description}</p>
            </div>
          </div>

          <div className="bg-[#fff] text-primary-text sm:mt-[0] mt-[32px] text-heading-6 mb-[40px] justify-center text-center p-2 md:min-h-[42px] xl:min-h-[48px] w-full flex">
            {data?.sub_title}
          </div>

          {!isMobile && (
            <>
              {/* samir bhai */}
              <div className="grid grid-cols-1 xl:grid-cols-12 sm:grid-cols-6 gap-8 w-full">
                {data?.cards?.map((card: any, index: number) => {
                  const number = String(index + 1).padStart(2, "0"); // 01, 02, 03...
                  const isEven = index % 2 !== 0; // decide image order
                  const bgImage = isEven
                    ? "bg-[url(/images/manufacturing/bg-green-card.png)] bg-bottom"
                    : "bg-[url(/images/manufacturing/bg-card.png)] bg-top";

                  return (
                    <div
                      key={index}
                      className="bg-white w-full overflow-hidden col-span-3 min-h-[291px] group cursor-pointer"
                    >
                      <div className="text-center">
                        {/* Image first for odd, last for even */}
                        {!isEven && (
                          <>
                            <div
                              className="
                                h-[387px] max-h-[387px] w-full overflow-hidden
                                opacity-100 md:opacity-100 xl:opacity-20
                                xl:group-hover:opacity-100 transition-all
                              "
                            >
                              <Image
                                src={toWebp(
                                  `${baseUrl}${card?.hover_image?.data?.attributes?.url}`,
                                )}
                                width={285 * 2}
                                height={387 * 2}
                                alt={card?.title || `card-${number}`}
                                className="w-full h-full object-cover"
                                quality={100}
                                sizes="100vw"
                              />
                            </div>
                            {/* Number */}
                            <div
                              className={`text-subtitle-3 font-semibold p-[16px] text-blue-500 xl:bg-blue-50 xl:group-hover:bg-[#fff] md:bg-[#fff] max-[1365px]:bg-[#fff]`}
                            >
                              {number}
                            </div>
                          </>
                        )}

                        {/* Text block */}
                        <div
                          className={`px-[16px] py-[27px]  
                          relative font-semibold flex 
                          flex-col items-center justify-center 
                          min-h-[392px] bg-cover bg-no-repeat
                          ${bgImage}
                          `}
                        >
                          <CardTitle card={card} index={index} />
                          <IpadCardTitle card={card} index={index} />
                        </div>

                        {/* Image last for even */}
                        {isEven && (
                          <>
                            <div
                              className={`text-subtitle-3 font-semibold p-[16px] text-green-500 xl:bg-green-50 xl:group-hover:bg-[#fff] md:bg-[#fff] max-[1365px]:bg-[#fff]`}
                            >
                              {number}
                            </div>
                            <div
                              className="
                                h-[387px] max-h-[387px] w-full overflow-hidden
                                opacity-100 md:opacity-100 xl:opacity-20
                                xl:group-hover:opacity-100 transition-all
                              "
                            >
                              <Image
                                src={toWebp(
                                  `${baseUrl}${card?.hover_image?.data?.attributes?.url}`,
                                )}
                                width={285 * 2}
                                height={387 * 2}
                                alt={card?.title || `card-${number}`}
                                className="w-full h-full object-cover"
                                quality={100}
                                sizes="100vw"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {isMobile && (
            <MobileSlider>
              {data?.cards?.map((card: any, index: number) => {
                const number = String(index + 1).padStart(2, "0"); // 01, 02, 03...
                const isEven = (index + 1) % 2 === 0; // for styling differences
                const bgImage = isEven
                  ? "bg-[url(/images/manufacturing/bg-green-card.png)] bg-bottom"
                  : "bg-[url(/images/manufacturing/bg-card.png)] bg-top";

                return (
                  <div
                    key={index}
                    className="bg-white w-full overflow-hidden min-h-[291px] group cursor-pointer"
                  >
                    <div className="text-center">
                      {/* Image */}
                      {!isEven ? (
                        <div className="h-[387px] max-h-[387px] w-full overflow-hidden opacity-100 group-hover:opacity-20 transition-all">
                          <Image
                            src={`${baseUrl}${card.hover_image.data.attributes.url}`}
                            width={600}
                            height={600}
                            alt={`card-${number}`}
                            className="w-full object-cover h-full"
                            quality={100}
                          />
                        </div>
                      ) : (
                        <div
                          className={`px-[16px] py-[27px] relative font-semibold flex flex-col items-center justify-center min-h-[392px] bg-cover bg-no-repeat
                          ${bgImage}
                          `}
                        >
                          <p
                            className="absolute xl:opacity-0 translate-y-4 
                                        transition-all duration-500 ease-out text-primary-text 
                                        text-heading-6 leading-relaxed xl:group-hover:opacity-100 xl:group-hover:translate-y-0 "
                          >
                            {card.title}
                          </p>
                        </div>
                      )}

                      {/* Number */}
                      <div
                        className={`text-subtitle-3 font-semibold p-[16px] bg-[#fff] ${
                          isEven ? "text-green-500 " : "text-blue-500 "
                        }`}
                      >
                        {number}
                      </div>

                      {isEven ? (
                        <div className="h-[387px] max-h-[387px] w-full overflow-hidden opacity-100 group-hover:opacity-20 transition-all">
                          <Image
                            src={`${baseUrl}${card.hover_image.data.attributes.url}`}
                            width={600}
                            height={600}
                            alt={`card-${number}`}
                            className="w-full object-cover h-full"
                            quality={100}
                          />
                        </div>
                      ) : (
                        <div
                          className={`
                            px-[16px] py-[27px] relative 
                            font-semibold flex flex-col 
                            items-center justify-center 
                            min-h-[392px] bg-cover bg-no-repeat
                            ${bgImage}
                          `}
                        >
                          <p
                            className="absolute xl:opacity-0 translate-y-4 
                                        transition-all duration-500 ease-out text-primary-text 
                                        text-heading-6 leading-relaxed 
                                        xl:group-hover:opacity-100 xl:group-hover:translate-y-0
                                       
                                        "
                          >
                            {card.title}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </MobileSlider>
          )}

          <div>
            <p className="text-subtitle-2 text-secondary-text my-[40px] mb-0 sm:mt-[40px] mt-[8px]">
              {data?.description_two}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Software;
